import React, { useEffect, useState } from "react";
import { achievementtourwise } from "../../../../services/superadmin";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";

export const TournamentAchieve = () => {
  const columnDefs = [
    {
      headerName: "Username (UID)",
      width: 150,
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      width: 150,
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
        headerName: "Gender",
        width: 150,
        field: "gender",
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: true,
        cellStyle: { textAlign: "left" },
      },
    {
      headerName: "ESID",
      width: 150,
      field: "esid",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
        headerName: "Tournament Date",
        width: 150,
        field: "meet_date",
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: function (params) {
            if (params.value !== null) {
                return moment(params.value).format("DD-MM-YYYY");
            }
        }
      },
    {
      headerName: "Level",
      width: 150,
      field: "meet_level",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Sports",
      width: 150,
      field: "sports_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Age Group",
      width: 150,
      field: "age_group",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event",
      width: 150,
      field: "event",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Position",
      width: 150,
      field: "position",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  const [filterProduct, setFilterProduct] = useState([]);
  const navigate = useNavigate();
  const [AData, setAData] = useState("");

  useEffect(() => {
    const storedData = localStorage.getItem("photoUpload");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setAData(parsedData);
      const temp = new FormData();
      temp.append("tournament_name", parsedData.meetName);
      temp.append("tournament_year", parsedData.year);
      temp.append("school_id", 0);

      achievementtourwise(temp).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data.achievementlist);
        }
      });
    } else {
      navigate("/superadmin/achievementstournamentlist");
    }
  }, []);

  function backlist() {
    if (localStorage.getItem("Role") == 1) {
        localStorage.removeItem("photoUpload");
      dotracking(
        "back button in achievement tournament list for " +
          AData.meetName +
          " $$ " +
          trackobj.achievetourlistheading
      );
      navigate("/superadmin/achievementstournamentlist");
    }else if (localStorage.getItem("Role") == 3) {
      localStorage.removeItem("photoUpload");
    dotracking(
      "back button in achievement tournament list for " +
        AData.meetName +
        " $$ " +
        trackobj.achievetourlistheading
    );
    navigate("/cityregional/achievementstournamentlist");
  }
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Achievements Lists</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Tournament</a>
          </li>

          <li className="breadcrumb-item active" aria-current="page">
            Achievements Lists
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-10">
                  <div className="text-left">
                    <h3>{AData.meetName}</h3>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="text-right">
                    <a className="btn btn-gray" onClick={backlist}>
                      <i className="fe fe-corner-up-left"></i> Back
                    </a>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
